/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BalanceResponse as AgentApiContractBalanceResponse } from '../../models/AgentApi/Contract/balance-response';

export interface ApiAgentGetBalanceGet$Plain$Params {
  lang?: string;
}

export function apiAgentGetBalanceGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentGetBalanceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractBalanceResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetBalanceGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractBalanceResponse>;
    })
  );
}

apiAgentGetBalanceGet$Plain.PATH = '/api/Agent/GetBalance';
